/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Controller, useForm } from 'react-hook-form';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from 'primereact/datatable';
import { Column, ColumnEditorOptions } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { RawMaterialGroupService } from '../../service/RawMaterialGroupService';
import { Dropdown } from 'primereact/dropdown';
import { RawMaterialMasterService } from '../../service/RawMaterialMasterService';
import { SetupOptionsService } from '../../service/SetupOptionsService';
import RawMaterialGroup from '../../models/RawMaterialGroup';
import MaterialColorFabricReference from '../../models/MaterialColorFabricReference';
import MaterialNumber from '../../models/MaterialNumber';
import SetupOptionsColor from '../../models/SetupOptionsColor';
import SetupOptionsSize from '../../models/SetupOptionsSize';
import { Link, useParams } from 'react-router-dom';
import { Divider } from 'primereact/divider';
import { FilterMatchMode } from 'primereact/api';
import { Card } from 'primereact/card';

const RawMaterialGroupView = () => {
    let emptyRawMaterialGroup: RawMaterialGroup = {
        id: 0,
        raw_Material_Group: '',
        description: '',
        isExcluded: false,
        isUsed: false,
        hasColorCodes: false
    };

    let emptyMaterialColorFabricReference: MaterialColorFabricReference = {
        id: 0,
        raw_Material_Group: undefined,
        color_Code: '',
        base_Color_Code: '',
        size: '',
        material_Number: '',
        materialNumberDescription: ''
    }

    const [materialColorFabricReferences, setMaterialColorFabricReferences] = useState<MaterialColorFabricReference[]>([]);
    const [materialNumbers, setMaterialNumbers] = useState<MaterialNumber[]>([]);
    const [setupOptionsColors, setSetupOptionsColors] = useState<SetupOptionsColor[]>([]);
    const [setupOptionsSizes, setSetupOptionsSizes] = useState<SetupOptionsSize[]>([]);
    const [loadingColorSizeMaterialNumber, setLoadingColorSizeMaterialNumber] = useState(true);
    const [deleteMaterialColorFabricReferenceDialog, setDeleteMaterialColorFabricReferenceDialog] = useState(false);
    const [rawMaterialGroup, setRawMaterialGroup] = useState<any>(emptyRawMaterialGroup);
    const [materialColorFabricReference, setMaterialColorFabricReference] = useState<MaterialColorFabricReference>(emptyMaterialColorFabricReference);
    const [newMaterialNumberDescription, setNewMaterialNumberDescription] = useState<string | null | undefined>('');
    const [editMaterialNumberDescription, setEditMaterialNumberDescription] = useState<string | null | undefined>('');
    const [setupColorDescription, setSetupColorDescription] = useState<string | undefined>('');
    const [setupColorEditDescription, setSetupColorEditDescription] = useState<string | undefined>('');
    const [setupSizeDescription, setSetupSizeDescription] = useState<string | undefined>('');
    const [setupSizeEditDescription, setSetupSizeEditDescription] = useState<string | undefined>('');
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const [filters, setFilters] = useState<DataTableFilterMeta>({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [editingRows, setEditingRows] = useState({});
    const isNew = useRef(false);
    const toast = useRef<any>(null);
    const dtMaterialColorFabricReferences = useRef<any>(null);
    const ddEditColorCode = useRef<Dropdown>(null);
    const ddEditSize = useRef<Dropdown>(null);
    const ddEditMaterialNumber = useRef<Dropdown>(null);
    const ddNewColorCode = useRef<Dropdown>(null);
    const ddNewSize = useRef<Dropdown>(null);
    const ddNewMaterialNumber = useRef<Dropdown>(null);
    const btnClearMaterialColorFabricReference = useRef<Button>(null);
    const btnResetMaterialColorFabricReference = useRef<any>();
    const { id } = useParams();

    useEffect(() => {
        if (!id) { return; }

        !loadingColorSizeMaterialNumber && setLoadingColorSizeMaterialNumber(true);

        RawMaterialGroupService.getRawMaterialGroup(Number(id)).then(data => setRawMaterialGroup(data));
        RawMaterialMasterService.getMaterialNumbers().then(data => setMaterialNumbers(data));
        SetupOptionsService.getSetupOptionsColors().then(data => setSetupOptionsColors(data));
        SetupOptionsService.getSetupOptionsSizes().then(data => setSetupOptionsSizes(data));
        RawMaterialGroupService.getMaterialColorFabricReferences(Number(id)).then(materialColorFabricReferenceData => {
            setMaterialColorFabricReferences(materialColorFabricReferenceData);
            setLoadingColorSizeMaterialNumber(false);
        });
    }, []);

    const defaultMaterialColorReferenceValues : Record<string, any> = { 
        color_Code: null,
        size: null,
        material_Number: null
    };

    const { 
        control: controlMaterialColorFabricReference, 
        formState: { errors: errorsMaterialColorFabricReference }, 
        trigger: triggerMaterialColorFabricReference,
        clearErrors: clearErrorsMaterialColorFabricReference,
        reset: resetMaterialColorFabricReference,
        handleSubmit: handleSubmitMaterialColorFabricReference } = useForm({ defaultValues: defaultMaterialColorReferenceValues, mode: "all" });

    const formEditMaterialColorFabricReference = useForm({ mode: "all" });

    const onSubmitMaterialColorFabricReference = (data: any) => {
        isNew.current = true;
        let _materialColorFabricReference = { ...materialColorFabricReference };
        _materialColorFabricReference.raw_Material_Group = rawMaterialGroup.id;
        _materialColorFabricReference.color_Code = data.color_Code;
        _materialColorFabricReference.base_Color_Code = setupOptionsColors.find((v) => v.colorCode === data.color_Code)?.baseColorCode;
        _materialColorFabricReference.size = data.size;
        _materialColorFabricReference.material_Number = data.material_Number;
        _materialColorFabricReference.materialNumberDescription = materialNumbers.find((v) => v.materialNumber === data.material_Number)?.description;
        saveMaterialColorFabricReference(_materialColorFabricReference);
    };

    const getColorSizeMaterialNumberErrorMessage = (name: string) => {
        return errorsMaterialColorFabricReference[name] ? <small className="p-error">{(errorsMaterialColorFabricReference[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };
    
    const getSetupColorDescription = (colorCode: string, isEdit: boolean) => {
        let _setupOptionsColors = [ ...setupOptionsColors ];
        let _setupColorDescription = _setupOptionsColors.filter((v) => v.colorCode === colorCode).map((val) => { return val.description; })[0];
        setTimeout(() => isEdit ? setSetupColorEditDescription(_setupColorDescription) : setSetupColorDescription(_setupColorDescription), 0);
    };

    const getSetupSizeDescription = (size: string, isEdit: boolean) => {
        let _setupOptionsSizes = [ ...setupOptionsSizes ];
        let _setupSizeDescription = _setupOptionsSizes.filter((v) => v.size === size).map((val) => { return val.description; })[0];
        setTimeout(() => isEdit ? setSetupSizeEditDescription(_setupSizeDescription) : setSetupSizeDescription(_setupSizeDescription), 0);
    };

    const hideDeleteMaterialColorFabricReferenceDialog = () => {
        setDeleteMaterialColorFabricReferenceDialog(false);
    };

    const saveMaterialColorFabricReference = (materialColorFabricReferenceData: MaterialColorFabricReference) => {
        let _materialColorFabricReferences = [...materialColorFabricReferences];

        if (isNew.current) {
            RawMaterialGroupService.addMaterialColorFabricReference(materialColorFabricReferenceData).then((data) => {
                if (data) {
                    data.materialNumberDescription = materialNumbers.filter((v) => v.materialNumber === data.material_Number).map((val) => { return val.description; })[0];
                    _materialColorFabricReferences.push(data);
                    setMaterialColorFabricReferences(_materialColorFabricReferences);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Material Color Fabric Reference Created', life: 3000 });
                    setMaterialColorFabricReference(emptyMaterialColorFabricReference);
                    _materialColorFabricReferences.sort(function (a, b) { return (a.color_Code === undefined || b.color_Code === undefined || a.color_Code < b.color_Code) ? -1 : (a.color_Code < b.color_Code) ? 1 : 0; });
                    dtMaterialColorFabricReferences.current.props.value = _materialColorFabricReferences;
                    resetMaterialColorFabricReference();
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Material Color Fabric Reference', life: 3000 });
                }
            });
        } else {
            RawMaterialGroupService.updateMaterialColorFabricReference(materialColorFabricReferenceData).then((data) => {
                if (data) {
                    let index = materialColorFabricReferences.findIndex(r => r.id === materialColorFabricReferenceData.id);
                    _materialColorFabricReferences[index] = materialColorFabricReferenceData;
                    setMaterialColorFabricReferences(_materialColorFabricReferences);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Material Color Fabric Reference Updated', life: 3000 });
                    setMaterialColorFabricReference(emptyMaterialColorFabricReference);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Material Color Fabric Reference', life: 3000 });
                }
            });
        }
    }

    const confirmDeleteMaterialColorFabricReference = (materialColorFabricReference: MaterialColorFabricReference) => {
        setMaterialColorFabricReference(materialColorFabricReference);
        setDeleteMaterialColorFabricReferenceDialog(true);
    }

    const deleteMaterialColorFabricReference = () => {
        RawMaterialGroupService.deleteMaterialColorFabricReference(materialColorFabricReference.id).then((data) => {
            if (data) {
                let _materialColorFabricReferences = materialColorFabricReferences.filter(val => val.id !== materialColorFabricReference.id);
                setMaterialColorFabricReferences(_materialColorFabricReferences);
                setDeleteMaterialColorFabricReferenceDialog(false);
                setMaterialColorFabricReference(emptyMaterialColorFabricReference);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Material Color Fabric Reference Deleted', life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Delete Material Color Fabric Reference', life: 3000 });
            }
        });
    }

    const getMaterialNumberDescription = (materialNumber: string) => {
        let _materialNumbers = [ ...materialNumbers ];
        let _materialNumberDescription = _materialNumbers.filter((v) => v.materialNumber === materialNumber).map((val) => { return val.description; })[0];
        setNewMaterialNumberDescription(_materialNumberDescription);
    };

    const getEditMaterialNumberDescription = (materialNumber: string) => {
        let _materialNumbers = [ ...materialNumbers ];
        let _materialNumberDescription = _materialNumbers.filter((v) => v.materialNumber === materialNumber).map((val) => { return val.description; })[0];
        setEditMaterialNumberDescription(_materialNumberDescription);
    };

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const setMaterialColorFabricReferenceActiveRowIndex = (rowData: DataTableSelectionSingleChangeEvent<MaterialColorFabricReference[]>) => {
        let selectedMaterialColorFabricReferenceIndex = materialColorFabricReferences.findIndex(v => v.id === (rowData.value as MaterialColorFabricReference).id);
        let _editingRows = { ...editingRows, ...{ [`${materialColorFabricReferences[selectedMaterialColorFabricReferenceIndex].id}`]: true } };
        
        if(Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const colorCodeEditor = (options: any) => {
        return (
            <Controller 
                name="colorCodeEdit" 
                control={formEditMaterialColorFabricReference.control}
                defaultValue={options.value}
                rules={{
                    validate: {
                        unique: (v) => {
                            let _materialColorFabricReferences = [ ...materialColorFabricReferences ];
                            
                            if (formEditMaterialColorFabricReference.getValues("sizeEdit") === undefined) {
                                if (ddEditSize.current?.props.value !== '') {
                                    let _materialColorFabricReferencesUniqueSize = _materialColorFabricReferences.filter((val) => val.color_Code === v && val.size === ddEditSize.current?.props.value);
                                    return _materialColorFabricReferencesUniqueSize.length === 0 || 'Color Code and Size already exists.';
                                } else {
                                    return _materialColorFabricReferences.filter((val) => val.color_Code === v).length === 0 || 'Color Code is not unique.'
                                }
                            } else {
                                let _materialColorFabricReferencesUniqueSize = _materialColorFabricReferences.filter((val) => val.color_Code === v && val.size === formEditMaterialColorFabricReference.getValues("sizeEdit"));
                                return _materialColorFabricReferencesUniqueSize.length === 0 || 'Color Code and Size already exists.';
                            }
                        }
                    }
                }}
                render={({ field, fieldState }) => {
                    materialColorFabricReference.color_Code = field.value;
                    getSetupColorDescription(field.value === undefined ? options.value : field.value, true);

                    return (
                        <>
                            <Dropdown
                                ref={ddEditColorCode}
                                value={fieldState.isDirty ? field.value : options.value}
                                options={setupOptionsColors}
                                optionLabel="colorCode"
                                optionValue="colorCode"
                                virtualScrollerOptions={{ itemSize: 38 }}
                                tooltip={fieldState.invalid ? fieldState.error?.message : setupColorEditDescription}
                                tooltipOptions={{ position: 'bottom' }}
                                className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => {
                                    materialColorFabricReference.color_Code = e.value;
                                    field.onChange(e.value);
                                    getSetupColorDescription(e.value, true);
                                    formEditMaterialColorFabricReference.clearErrors();
                                    formEditMaterialColorFabricReference.trigger();
                                }} 
                                filter
                                filterBy="colorCode"
                                placeholder="Color Code" />
                        </>
                    )} 
                }
            />
        );
    }

    const sizeEditor = (options: any) => {
        return (
            <Controller
                name="sizeEdit" 
                control={formEditMaterialColorFabricReference.control}
                defaultValue={options.value}
                rules={{
                    validate: {
                        unique: (v) => {
                            let _materialColorFabricReferences = [ ...materialColorFabricReferences ];

                            if (formEditMaterialColorFabricReference.getValues("sizeColorCode") === undefined) {
                                if (v === undefined) {
                                    let _materialColorFabricReferencesUniqueSizeColorCode = _materialColorFabricReferences.filter((val) => val.color_Code === ddEditColorCode.current?.props.value && val.size === ddEditSize.current?.props.value);
                                    return _materialColorFabricReferencesUniqueSizeColorCode.length === 0 || 'Color Code and Size already exists.';
                                } else {
                                    let _materialColorFabricReferencesUniqueSizeColorCode = _materialColorFabricReferences.filter((val) => val.color_Code === ddEditColorCode.current?.props.value && val.size === v);
                                    return _materialColorFabricReferencesUniqueSizeColorCode.length === 0 || 'Color Code and Size already exists.';
                                }
                            } else {
                                let _materialColorFabricReferencesUniqueSizeColorCode = _materialColorFabricReferences.filter((val) => val.color_Code === formEditMaterialColorFabricReference.getValues("sizeColorCode") && val.size === v);
                                return _materialColorFabricReferencesUniqueSizeColorCode.length === 0 || 'Color Code and Size already exists.';
                            }
                        }
                    }
                }} 
                render={({ field, fieldState }) => {
                    materialColorFabricReference.size = field.value;
                    getSetupSizeDescription(field.value === undefined ? options.value : field.value, true);

                    return (
                        <>
                            <Dropdown
                                ref={ddEditSize}
                                value={fieldState.isDirty ? field.value : options.value}
                                options={setupOptionsSizes}
                                optionLabel="size"
                                optionValue="size"
                                virtualScrollerOptions={{ itemSize: 38 }}
                                tooltip={fieldState.invalid ? fieldState.error?.message : setupSizeEditDescription}
                                tooltipOptions={{ position: 'bottom' }}
                                className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => {
                                    materialColorFabricReference.size = e.value;
                                    field.onChange(e.value);
                                    getSetupSizeDescription(e.value, true);
                                    formEditMaterialColorFabricReference.clearErrors();
                                    formEditMaterialColorFabricReference.trigger();
                                }}
                                filter
                                filterBy="size"
                                placeholder="Size" />
                        </>
                    )} 
                }
            />
        );
    }

    const materialNumberEditor = (options: any) => {
        return (
            <Controller
                name="materialNumberEdit"
                control={formEditMaterialColorFabricReference.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    materialColorFabricReference.material_Number = field.value;

                    return (
                        <>
                            <Dropdown 
                                ref={ddEditMaterialNumber}
                                value={fieldState.isDirty ? field.value : options.value}
                                options={materialNumbers}
                                optionLabel="materialNumber"
                                optionValue="materialNumber"
                                virtualScrollerOptions={{ itemSize: 38 }}
                                className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => {
                                    materialColorFabricReference.material_Number = e.value;
                                    field.onChange(e.value);
                                    getEditMaterialNumberDescription(e.value);
                                    options.rowData.description = newMaterialNumberDescription
                                }}
                                filter
                                filterBy="materialNumber"
                                placeholder="Material Number" />
                        </>
                    )} 
                }
            />
        );
    }

    const materialNumberDescriptionEditor = (options: any) => {
        return (
            <>
                <span>{(editMaterialNumberDescription === null || editMaterialNumberDescription === undefined || editMaterialNumberDescription === '') ? options.value : editMaterialNumberDescription}</span>
            </>
        );
    }

    const colorCodeBodyTemplate = (rowData: MaterialColorFabricReference) => {
        return rowData.color_Code;
    }

    const sizeBodyTemplate = (rowData: MaterialColorFabricReference) => {
        return rowData.size;
    }

    const materialNumberBodyTemplate = (rowData: MaterialColorFabricReference) => {
        return rowData.material_Number;
    }

    const materialNumberDescriptionBodyTemplate = (rowData: MaterialColorFabricReference) => {
        return rowData.materialNumberDescription;
    }

    const rowEditorMaterialColorFabricReferenceTemplate = (rowData: MaterialColorFabricReference, props: any) => {
        const rowEditor = props.rowEditor;

        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEditMaterialColorFabricReference.getFieldState("colorCodeEdit").invalid && !formEditMaterialColorFabricReference.getFieldState("sizeEdit").invalid && !formEditMaterialColorFabricReference.getFieldState("materialNumberEdit").invalid) {
                            let _materialColorFabricReference = { ...materialColorFabricReference };
                            _materialColorFabricReference.id = rowData.id;
                            _materialColorFabricReference.raw_Material_Group = rawMaterialGroup.id;
                            _materialColorFabricReference.color_Code = ddEditColorCode.current?.props.value;
                            _materialColorFabricReference.base_Color_Code = setupOptionsColors.find((v) => v.colorCode === rowData.color_Code)?.baseColorCode;
                            _materialColorFabricReference.size = ddEditSize.current?.props.value;
                            _materialColorFabricReference.material_Number = ddEditMaterialNumber.current?.props.value;
                            _materialColorFabricReference.materialNumberDescription = editMaterialNumberDescription;
                            saveMaterialColorFabricReference(_materialColorFabricReference);
                            formEditMaterialColorFabricReference.clearErrors();
                            formEditMaterialColorFabricReference.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />
                    
                    <Button ref={btnClearMaterialColorFabricReference} icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEditMaterialColorFabricReference.clearErrors();
                        formEditMaterialColorFabricReference.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <>
                    <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDeleteMaterialColorFabricReference(rowData)} to={''}></Link>
                </>
            );
        }
    }

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const headerMaterialColorFabricReferencesTable = (
        <div className="flex flex-column md:flex-row md:justify-content-end md:align-items-center">
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const deleteMaterialColorFabricReferenceDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteMaterialColorFabricReferenceDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteMaterialColorFabricReference} />
        </>
    );

    const rawMaterialGroupTitle = (
        <>
            <div className="flex flex-wrap">
                <div className="flex align-items-center">
                    <label className="font-bold text-lg">Raw Material Group:</label>
                    <label className="ml-2 text-primary font-bold text-lg">{`${rawMaterialGroup.raw_Material_Group}`}</label>
                    {rawMaterialGroup.isExcluded && <label className="ml-2 text-red-500 font-bold text-lg">(Excluded From BOM)</label>}
                </div>
            </div>
        </>
    );

    const rawMaterialGroupSubTitle = (
        <>
            <div className="flex flex-wrap">
                <div className="flex align-items-center">
                    <label className="ml-2 font-bold">Description:</label>
                    <label className="ml-2 text-primary font-bold">{`${rawMaterialGroup.description}`}</label>
                </div>
            </div>

            <Divider/>
        </>
    );

    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Toast ref={toast} />

                <Card className="layout-main-card border-noround" title={rawMaterialGroupTitle} subTitle={rawMaterialGroupSubTitle}>
                    <Panel header="Add Color/Size/Material Number" className="addPanel mb-2">
                        <form key={2} onSubmit={handleSubmitMaterialColorFabricReference(onSubmitMaterialColorFabricReference)} className="p-fluid" autoComplete="off">
                            <div className="formgrid grid">
                                <div className="field col-2">
                                    <Controller
                                        name="color_Code"
                                        control={controlMaterialColorFabricReference}
                                        rules={{
                                            validate: {
                                                unique: (v) => {
                                                    let _materialColorFabricReferences = [ ...materialColorFabricReferences ];

                                                    if (ddNewSize.current?.props.value || ddNewMaterialNumber.current?.props.value !== '') {
                                                        if (ddNewSize.current?.props.value === null){
                                                            let sizeStr = ddNewSize.current?.props.value ?? '';
                                                            let _materialColorFabricReferencesUniqueSize = _materialColorFabricReferences.filter((val) => val.color_Code === v && val.size === sizeStr && val.material_Number === ddNewMaterialNumber.current?.props.value);
                                                            return _materialColorFabricReferencesUniqueSize.length === 0 || 'Color Code and Size already exists.';
                                                        }
                                                        else if (ddNewSize.current?.props.value === ''){
                                                            let sizeStr = ddNewSize.current?.props.value ?? '';
                                                            let _materialColorFabricReferencesUniqueSize = _materialColorFabricReferences.filter((val) => val.color_Code === v && val.size === sizeStr && val.material_Number === ddNewMaterialNumber.current?.props.value);
                                                            return _materialColorFabricReferencesUniqueSize.length === 0 || 'Color Code and Size already exists.';
                                                        }
                                                        
                                                    } else {
                                                        return _materialColorFabricReferences.filter((val) => val.color_Code === v).length === 0 || 'Color Code is not unique.'
                                                    }
                                                }
                                            }
                                        }}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <label htmlFor={field.name} className="font-bold text-xs">Color Code</label>
                                                <Dropdown ref={ddNewColorCode} inputId={field.name} value={field.value} options={setupOptionsColors} optionLabel="colorCode" optionValue="colorCode" virtualScrollerOptions={{ itemSize: 38 }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => {getSetupColorDescription(e.value, false); field.onChange(e.value); triggerMaterialColorFabricReference(); }} showClear filter filterBy="colorCode" placeholder="Color Code" />
                                                {!fieldState.invalid && field.value !== null && field.value !== undefined && field.value !== '' ? <small className="text-primary">{setupColorDescription}</small> : <></>}
                                                {getColorSizeMaterialNumberErrorMessage('color_Code')}
                                            </>
                                        )}
                                    />
                                </div>
                                <div className="field col-2">
                                    <Controller
                                        name="size"
                                        control={controlMaterialColorFabricReference}
                                        rules={{
                                            validate: {
                                                unique: (v) => {
                                                    let result = true;
                                                    let _materialColorFabricReferences = [ ...materialColorFabricReferences ];

                                                    if (v !== '') {
                                                        let _materialColorFabricReferencesUniqueSizeColorCode = _materialColorFabricReferences.filter((val) => val.color_Code === ddNewColorCode.current?.props.value && val.size === v);
                                                        return _materialColorFabricReferencesUniqueSizeColorCode.length === 0 || 'Color Code and Size already exists.';
                                                    } else {
                                                        return result;
                                                    }
                                                }
                                            }
                                        }}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <label htmlFor={field.name} className="font-bold text-xs">Size</label>
                                                <Dropdown ref={ddNewSize} inputId={field.name} value={field.value} options={setupOptionsSizes} optionLabel="size" optionValue="size" virtualScrollerOptions={{ itemSize: 38 }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => {getSetupSizeDescription(e.value, false); field.onChange(e.value); triggerMaterialColorFabricReference(); }} showClear filter filterBy="size" placeholder="Size" />
                                                {!fieldState.invalid && field.value !== null && field.value !== undefined && field.value !== '' ? <small className="text-primary">{setupSizeDescription}</small> : <></>}
                                                {getColorSizeMaterialNumberErrorMessage('size')}
                                            </>
                                        )}
                                    />
                                </div>
                                <div className="field col-2">
                                    <Controller
                                        name="material_Number"
                                        control={controlMaterialColorFabricReference}
                                        rules={{
                                            required: 'Material Number is required.',
                                            validate: {
                                                unique: (v) => {
                                                    let result = true;
                                                    let _materialColorFabricReferences = [ ...materialColorFabricReferences ];
                                                    
                                                    if (v !== '') {
                                                        let _materialColorFabricReferencesUniqueSizeColorCode = _materialColorFabricReferences.filter((val) => val.color_Code === ddNewColorCode.current?.props.value && val.size === v);
                                                        return _materialColorFabricReferencesUniqueSizeColorCode.length === 0 || 'Color Code and Size already exists.';
                                                    } else {
                                                        return result;
                                                    }
                                                }
                                            }
                                        }}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <label htmlFor={field.name} className="font-bold text-xs">Material Number</label>
                                                <Dropdown ref={ddNewMaterialNumber} inputId={field.name} value={field.value} options={materialNumbers} optionLabel="materialNumber" optionValue="materialNumber" virtualScrollerOptions={{ itemSize: 38 }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => {getMaterialNumberDescription(e.value); field.onChange(e.value); }} filter filterBy="materialNumber" showClear placeholder="Material Number" />
                                                {field.value !== null && field.value !== undefined && field.value !== '' ? <small className="text-primary">{newMaterialNumberDescription}</small> : <></>}
                                                {getColorSizeMaterialNumberErrorMessage('material_Number')}
                                            </>
                                        )}
                                    />
                                </div>
                                <div className="field field-buttons col-2 pt-4">
                                    <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                                    <Button ref={btnResetMaterialColorFabricReference} icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={() => {resetMaterialColorFabricReference(); clearErrorsMaterialColorFabricReference();}} />
                                </div>
                            </div>
                        </form>
                    </Panel>
                    
                    <DataTable ref={dtMaterialColorFabricReferences} value={materialColorFabricReferences} selectionMode="single" onSelectionChange={setMaterialColorFabricReferenceActiveRowIndex}
                        dataKey="id" size="small" rowHover={true} loading={loadingColorSizeMaterialNumber}
                        sortField="color_Code"
                        scrollable scrollHeight="calc(100vh - 30.7rem)"
                        paginator alwaysShowPaginator={false} rows={25} rowsPerPageOptions={[5, 10, 25]} 
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} colors."
                        editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange}
                        filters={filters} emptyMessage="No color, size, and material numbers found." header={headerMaterialColorFabricReferencesTable}>
                        <Column field="color_Code" header="Color" body={colorCodeBodyTemplate} editor={(options:ColumnEditorOptions) => colorCodeEditor(options)} sortable align="center" alignHeader="center"></Column>
                        <Column field="size" header="Size" body={sizeBodyTemplate} editor={(options:ColumnEditorOptions) => sizeEditor(options)} sortable align="center" alignHeader="center"></Column>
                        <Column field="material_Number" header="Raw Material #" body={materialNumberBodyTemplate} editor={(options:ColumnEditorOptions) => materialNumberEditor(options)} sortable align="center" alignHeader="center"></Column>
                        <Column field="materialNumberDescription" header="Description" body={materialNumberDescriptionBodyTemplate} editor={(options:ColumnEditorOptions) => materialNumberDescriptionEditor(options)} sortable align="center" alignHeader="center"></Column>
                        <Column rowEditor body={rowEditorMaterialColorFabricReferenceTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                    </DataTable>

                    <Dialog visible={deleteMaterialColorFabricReferenceDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteMaterialColorFabricReferenceDialogFooter} onHide={hideDeleteMaterialColorFabricReferenceDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {materialColorFabricReference && <span>Are you sure you want to delete <b>{materialColorFabricReference.color_Code}</b>?</span>}
                        </div>
                    </Dialog>
                </Card>
            </div>
        </div>
    );
}

export default RawMaterialGroupView;